import { carbonDashboardStore } from "../stores";

export const useCarbonDashboardStore = () => carbonDashboardStore;
